import React from 'react';
import './candidate-auth.css';
import './admin-login-sizing.css';
import { CandidateValidationNotice } from './CandidateValidationNotice';
import { decrypt, URL } from '../variables';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/AppActions';
import './alert.css';
import moment from 'moment';

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            faculdade: null,
            token: {},
            loading: false,
            loading_send: false,
            msgErro: '',
            password: '',
            password_confirmation: '',
            password: '',
            redirect: false,
            path: '',
            msgSuccess: '',
            send: false,
            msgErroToken: ''
        }

    }

    login(event) {
        event.preventDefault();
        this.setState({ loading_send: true, msgErro: '' });
        let faculdade_id = null;
        if (this.state.faculdade != null) {
            faculdade_id = this.state.faculdade.id;
        }
        fetch(`${URL}api/auth/recovery_password?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                // 'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                password: this.state.password,
                password_confirmation: this.state.password_confirmation,
                token: this.props.match.params.token
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, loading_send: false, msgErro: erro, refresh: false, loadingMore: false });
                }
                else {
                    this.setState({ loading_send: false, msgSuccess: 'Senha alterar com sucesso.', send: true, credencial: '' });
                    // localStorage.setItem('token', resp.access_token);
                    // this.props.login({ token: resp.access_token, user: {} });
                    // this.setState({ redirect: true, path: '/home', loading: false });
                    // if (resp.faculdade != null) {
                    //     this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    // }
                    // else {
                    //     this.setState({ redirect: true, path: '/', loading: false });
                    // }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, loading_send: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, loading_send: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
            });
    }

    get_token(slug) {
        fetch(`${URL}api/auth/get_token/${slug}?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                // 'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, msgErro: erro, });
                }
                else {
                    if (resp.status == false) {
                        this.setState({ loading: false, msgErroToken: 'Este token de recuperação é inválido' });
                    }
                    else {
                        this.setState({ token: resp.token, faculdade: resp.token.faculdade, loading: false, msgErro: '' });

                    }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor', });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', });
            });
    }

    componentDidMount() {
        console.log('oiiii')
        const { match: { params } } = this.props;
        this.setState({ loading: true, msgErro: '' });
        this.get_token(params.token);
    }


    changeCPF(event) {
        let text = event.target.value
        let final_num = '';

        if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    if (!isNaN(text[i])) {
                        if (i == 3) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 6) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 9) {
                            final_num += '-' + text[i];
                        }
                        else {
                            final_num += text[i] + '';
                        }
                    }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changeEmail(event) {
        let text = event.target.value
        let final_num = '';
        final_num = text;
        this.setState({ credencial: final_num })
    }

    changeCPFEmail(event) {
        let text = event.target.value
        let final_num = '';
        if (text.length > 0 && isNaN(text[0])) {
            final_num = text;
            this.setState({ credencial: final_num })
        }
        else if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    // if (Number.isInteger(text[i])) {
                    if (i == 3) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 6) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 9) {
                        final_num += '-' + text[i];
                    }
                    else {
                        final_num += text[i] + '';
                    }
                    // }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changePassword(event) {
        this.setState({ password: event.target.value })
    }

    render() {
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.loading && <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> <div className="spinner-border text-primary" role="status"  >
                    <span className="sr-only">{"Carregando..."}</span>
                </div></div>}
                {!this.state.loading  && <div className="candidate-login-layout">
                    <section className="candidate-login-panel">
                        <div className="candidate-login-form-wrap">
                                <div className="candidate-login-logo">
                                    <img src={(this.state.faculdade && this.state.faculdade.logo) || require('../assets/images/logo-ontest.png')}
                                        alt={(this.state.faculdade && this.state.faculdade.name) || "OnTest"} />
                                </div>

                                <div className="candidate-login-form">
                                    <span className="candidate-auth-kicker">{"Ambiente do candidato"}</span>
                                    <h1>{"Alterar senha"}</h1>
                                    <p>{"Digite sua nova senha e confirme para continuar."}</p>

                                    <form className="form-horizontal m-t-30" onSubmit={this.login.bind(this)}>

                                        <div className="form-group row candidate-auth-field">


                                            {this.state.msgSuccess != '' && <div className="col-12"><div className="alert alert-success2  alert-dismissible fade show" role="alert">
                                                <button onClick={() => this.setState({ msgSuccess: '' })} type="button" className="close" data-dismiss="alert" aria-label={"Fechar"}>
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <p style={{ margin: 0 }}>{this.state.msgSuccess}</p>
                                            </div></div>}
                                            {<div className="col-12">
                                                <label>{"Nova senha"} <span>*</span></label>
                                                <input id="password" type="password"
                                                    className="form-control" name="password"
                                                    placeholder={"Digite sua nova senha"}
                                                    value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} required />

                                            </div>}

                                            {<div className="col-12 mt-3">
                                                <label>{"Confirmar senha"} <span>*</span></label>
                                                <input id="password_confirmation" type="password"
                                                    className="form-control" name="password_confirmation"
                                                    placeholder={"Repita sua nova senha"}
                                                    value={this.state.password_confirmation} onChange={(e) => this.setState({ password_confirmation: e.target.value })} required />

                                            </div>}


                                        </div>




                                        {this.state.msgErroToken == '' && <div className="form-group row m-t-20 candidate-login-action">
                                            {this.state.msgErro != '' && <div className="col-sm-12">
                                                <CandidateValidationNotice tone="danger">{this.state.msgErro}</CandidateValidationNotice>
                                            </div>}
                                            {this.state.loading_send == false && this.state.send==false && <div className="col-sm-12 text-right">
                                                <button className="btn btn-primary w-md waves-effect waves-light" type="submit">{"Salvar senha"} <i className="mdi mdi-arrow-right"></i></button>

                                            </div>}

                                            {this.state.loading_send == false && this.state.send==true && <div className="col-sm-12 text-right">
                                                <Link to={'/'+this.state.faculdade.slug+'/login'}><button className="btn btn-primary w-md waves-effect waves-light" type="button">{"Faça login"} <i className="mdi mdi-arrow-right"></i></button></Link>

                                            </div>}
                                            {this.state.loading_send == true && <div className="col-sm-12 text-right">
                                                <button className="btn btn-primary w-md waves-effect waves-light" type="button" disabled>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    {"Carregando..."}
                                                </button>
                                            </div>}
                                        </div>}
                                        {this.state.msgErroToken != '' && <div className="form-group row m-t-20 candidate-login-action">
                                            <div className="col-sm-12">
                                                <CandidateValidationNotice tone="danger">{this.state.msgErroToken}</CandidateValidationNotice>
                                            </div>
                                        </div>}

                                        <div className="form-group m-t-10 mb-0 row">
                                            <div className="col-12 m-t-20" style={{ textAlign: 'center' }}>

                                                {/* <a href="{{ action('Auth\ForgotPasswordController@showLinkRequestForm',$faculdade->slug) }}">
                                            <i className="mdi mdi-lock"></i>{{ __('Esqueceu sua senha?') }}
                                        </a>  */}
                                                {/* {this.state.faculdade == null && <a href="{{ action('Auth\ForgotPasswordController@showLinkRequestForm','admin') }}">
                                                    <i className="mdi mdi-lock"></i>Esqueceu sua senha?
                                        </a>} */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="candidate-login-footer">
                                    {/* <p>© {moment().format('YYYY')} OnTest</p> */}
                                </div>
                        </div>
                    </section>
                    <aside className="candidate-login-visual" style={{ backgroundImage: `url(${require("../assets/images/candidate-access-v2.png")})` }}>
                        <div className="candidate-login-visual-overlay"></div>
                        <div className="candidate-login-visual-copy">
                            <span>ONTEST</span>
                            <h2>{"Sua avaliação começa aqui."}</h2>
                            <p>{"Um ambiente organizado para você se concentrar, acompanhar seu tempo e realizar cada etapa com tranquilidade."}</p>
                        </div>
                    </aside>
                </div>}
            </div>
        );
    }


}

const mapsStateToProps = (state) => (
    {
    }
);

export default connect(mapsStateToProps, { login })(ChangePassword);
